import { render, staticRenderFns } from "./IbListViewPlaceholder.vue?vue&type=template&id=41e6fdcc"
import script from "./IbListViewPlaceholder.vue?vue&type=script&lang=js"
export * from "./IbListViewPlaceholder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports